import React, { PureComponent } from 'react'
// import _ from 'lodash'
import { Icon } from 'native-base'
import VStack from 'xui/components/VStack'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import XText from 'xui/components/XText'
import { View } from 'react-native'
import { Map } from 'immutable'
// import { UserGroup } from 'x/index'
import { STYLES, COLORS } from 'x/config/styles'
// import AddIcon from 'xui/components/AddIcon'
// import BackIcon from 'xui/components/BackIcon'
// import FastImage from 'react-native-fast-image'

const INTL_STYLES: { [key: string]: any } = {
  ugThumbnail: {
    height: 32,
    width: 32,
    borderRadius: 16,
    borderColor: COLORS.TEXT_INACTIVE,
    borderWidth: 0.5,
  },
  ugIconThumbnail: {
    color: COLORS.TEXT_INACTIVE,
    height: 32,
    width: 32,
    fontSize: 28,
    textAlign: 'center',
    borderRadius: 16,
  },
  txtNormalBold: {
    fontSize: STYLES.FONT_SIZE_NORMAL,
    color: COLORS.TEXT_ACTIVE,
    fontWeight: 'bold',
    marginTop: 0,
  },
  txtNormal: {
    fontSize: STYLES.FONT_SIZE_NORMAL,
    color: COLORS.TEXT_ACTIVE,
    marginTop: 0,
  },
  txtNormalLight: {
    fontSize: STYLES.FONT_SIZE_NORMAL,
    color: COLORS.TEXT_INACTIVE,
    marginTop: 0,
  },
}

interface IUserGroupItem {
  name: string
  description?: string
  thumbnail_uri?: string
}

export interface IUserGroupItemMap extends Map<string, any> {
  toJS(): IUserGroupItem
  get<K extends keyof IUserGroupItem>(key: K): IUserGroupItem[K]
}

export interface IUGDisplayItemProps extends IUserGroupItem {
  data?: IUserGroupItemMap
}

export default class UGDisplayItem extends PureComponent<IUGDisplayItemProps> {
  render() {
    const { data = null, name = null, description = null, thumbnail_uri = null } = this.props
    const txtName = Map.isMap(data) ? data.get('name') : name
    const txtDesc = Map.isMap(data) ? data.get('description') : description
    const txtThumbUri = Map.isMap(data) ? data.get('thumbnail_uri') : thumbnail_uri

    if (!txtName && !txtDesc && !txtThumbUri) {
      return null
    }

    return (
      <HStack w='full' py='2' px='3' flexWrap='wrap' space='2'>
        <VStack style={{ width: 32, marginRight: 8 }}>
          {txtThumbUri ? (
            <XImage
              resizeMode='cover'
              // style={INTL_STYLES.ugThumbnail}
              style={{ height: 32, width: 32 }}
              source={{ uri: txtThumbUri }}
            />
          ) : (
            <View style={INTL_STYLES.ugThumbnail}>
              <Icon style={INTL_STYLES.ugIconThumbnail} name='people' />
            </View>
          )}
        </VStack>
        <VStack flex={1} space='1'>
          <XText bold numberOfLines={2}>
            {txtName}
          </XText>
          {txtDesc ? <XText numberOfLines={2}>{txtDesc}</XText> : null}
        </VStack>
      </HStack>
    )
  }
}
